export default __webpack_public_path__ + "static/media/pref-completo.88a8d9dd.svg";